"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductList = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _components = require("../../components");
var _personalProductListEditContext = require("../../contexts/personalProductListEditContext");
var _useTranslations = require("../../hooks/useTranslations");
var _ProductListEdit = require("./ProductListEdit");
var _components2 = require("./components");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductList = ()=>{
    const { translations } = (0, _useTranslations.useTranslations)();
    const { isLoadingPersonalProductListDetail, personalProductListDetail, isLoadingProducts } = (0, _personalProductListEditContext.usePersonalProductListEditContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_presentationComponents.DashboardModule, {
                isIntro: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        variant: "h4",
                        component: "h4",
                        color: "textPrimary",
                        children: translations.productListDetailPageTitle
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Description, {
                        color: "textPrimary",
                        children: translations.productListDetailDescription
                    }),
                    isLoadingPersonalProductListDetail ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components2.Sharing, {
                        productList: personalProductListDetail
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.EditModule, {
                children: isLoadingPersonalProductListDetail || isLoadingProducts ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Loading, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ProductListEdit.ProductListEdit, {})
            })
        ]
    });
};
exports.ProductList = ProductList;
